export const CheckmarkSVG = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentcolor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.06665 8.40003L7.19998 10.1334L10.8 5.8667"
        stroke="current"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8" cy="8" r="7.25" stroke="current" strokeWidth="1" />
    </svg>
  );
};
